import { useState } from "react";
import { EntradaBitacora, Usuario } from "../../types";

interface BitacoraSectionProps {
  casoId: number;
  bitacora: EntradaBitacora[];
  usuarios: Usuario[];
  usuarioActual: Usuario;
  onEntradaCreate: (entrada: Omit<EntradaBitacora, "id" | "fechaCreacion">) => void;
}

export function BitacoraSection({
  casoId,
  bitacora,
  usuarios,
  usuarioActual,
  onEntradaCreate,
}: BitacoraSectionProps) {
  const [nuevaNota, setNuevaNota] = useState("");

  const getUsuarioNombre = (id: number) =>
    usuarios.find((u) => u.id === id)?.nombre || "Usuario";

  const formatDateTime = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleString("es-CL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (nuevaNota.trim()) {
      onEntradaCreate({
        casoId,
        usuarioId: usuarioActual.id,
        contenido: nuevaNota.trim(),
      });
      setNuevaNota("");
    }
  };

  const sortedBitacora = [...bitacora].sort(
    (a, b) => new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime()
  );

  return (
    <div className="space-y-4">
      {/* Formulario para nueva nota */}
      <div className="bg-white rounded-lg border border-slate-200 p-4">
        <form onSubmit={handleSubmit}>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Agregar nota a la bitacora
          </label>
          <textarea
            value={nuevaNota}
            onChange={(e) => setNuevaNota(e.target.value)}
            placeholder="Escribe una nota sobre el avance del caso..."
            rows={3}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
          />
          <div className="flex justify-end mt-3">
            <button
              type="submit"
              disabled={!nuevaNota.trim()}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors disabled:bg-slate-300 disabled:cursor-not-allowed"
            >
              Agregar Nota
            </button>
          </div>
        </form>
      </div>

      {/* Lista de entradas */}
      <div className="bg-white rounded-lg border border-slate-200">
        <div className="p-4 border-b border-slate-200">
          <h3 className="text-sm font-semibold text-slate-700">
            Historial ({bitacora.length} entradas)
          </h3>
        </div>

        {sortedBitacora.length > 0 ? (
          <div className="divide-y divide-slate-100">
            {sortedBitacora.map((entrada) => (
              <div key={entrada.id} className="p-4">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-slate-200 rounded-full flex items-center justify-center text-sm font-medium text-slate-600 flex-shrink-0">
                    {getUsuarioNombre(entrada.usuarioId).charAt(0)}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-sm font-medium text-slate-800">
                        {getUsuarioNombre(entrada.usuarioId)}
                      </span>
                      <span className="text-xs text-slate-500">
                        {formatDateTime(entrada.fechaCreacion)}
                      </span>
                    </div>
                    <p className="text-sm text-slate-600 whitespace-pre-wrap">
                      {entrada.contenido}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="p-8 text-center text-slate-500">
            No hay entradas en la bitacora
          </div>
        )}
      </div>
    </div>
  );
}
